module.exports = __webpack_public_path__ + "static/img/yi4.297a3be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yi4.jpg
// module id = 371B
// module chunks = 0